"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _styledComponents = require("styled-components");

var _default = (0, _styledComponents.css)(["&:after{content:\"\";display:table;clear:both;}"]);

exports["default"] = _default;